import Vue from 'vue'
import Vuex from 'vuex'
import VueAxios from "vue-axios";
import axios from "axios";

//import municipios from '@/datatablecolumns/municipios';
Vue.use(VueAxios, axios);

Vue.use(Vuex)

const base="https://api.metricadigital.com.mx/api/";
//const base="http://127.0.0.1:8000/api/";
export default new Vuex.Store({
  state: {
 baseapi:"https://api.metricadigital.com.mx/api/",
//baseapi:"http://127.0.0.1:8000/api/",

   

    user:{
      role:'admin'
    },
    arbol_problema:null,
    poasel:null,
    loading:false,
    backStyle:{
      Verde:{ 
            backgroundColor:"#00923f", 
            },
            Azul:{
            backgroundColor:"#06338e" 
            },
            Rojo:{
            backgroundColor:"#bf1906" 
            }
            },
             colorStyle:{
              Verde:{
            color:"#00923f", 
            },
            Azul:{
            color:"#06338e" 
            },
            Rojo:{
            color:"#bf1906" 
            },
            Naranja:{
            color:"#bf19bf" 
            }
            },
    datatables:{
      //municipios:new municipios()
    },
    indicador_administrador:null,
    secretaria_sel:null,
    funciones_sel:null,
    pmd_sel:null,
    eje_sel:null,
    mir_obj:null,
    estrategia_sel:null,
    objetivo_sel:null,
    lineas_sel:null,
    usu_muni : null,
    frecuancia_sel:null,
    finalidad_sel:null,
    departamento_sel:null,
    poa_sel:null,
    linea_accion_sel:null,
indicador_administrador_sel:null,
indicador_area_sel:null,
gobierno_sel:null,
sociales_sel:null,
economicos:null,
    menus:{
      admin:[
             { tag:'dashboard',ruta:'/su',active:false,child:false},
             { tag:'municipios',ruta:'/su/municipios',active:false,child:false},
             { tag:'paquetes',ruta:'/su/paquetes',active:false,child:false},
             { tag:'pagos',ruta:'/su/pagos',active:false,child:false},
            // { tag:'reporteador',ruta:'/su/reporteador',active:false,child:false},
             { tag:'usuarios',ruta:'/su/usuarios',active:false,child:false}
      ],
      municipios:[
      
         { tag:'general',child:true,active:false,childs:
         [
          { tag:'Pantalla Principal',child:false,active:false,ruta:'/mun/general/dash'},
          { tag:'poa_series',child:false,active:false,ruta:'/mun/general/series'},
             { tag:'dependencias',child:false,active:false,ruta:'/mun/general/secretarias'},
             { tag:'usuarios_municipio',child:false,active:false,ruta:'/mun/general/usuariosmunicipio'},
           /*  { tag:'departamentos',ruta:'/mun/general/departamentos'},
            { tag:'sitiosinteres',ruta:'/mun/general/sitiosi'},
             { tag:'premios_reconocimeintos',ruta:'/mun/general/premmiosr'}
              { tag:'informes',ruta:'/mun/general/informesresultado'},*/
             
         ]},
          { tag:'pmd',child:true,active:false,childs:
         [
             { tag:'pmd',child:false,active:false,ruta:'/mun/general/pmd'},
            
           /*  { tag:'departamentos',ruta:'/mun/general/departamentos'},
            { tag:'sitiosinteres',ruta:'/mun/general/sitiosi'},
             { tag:'premios_reconocimeintos',ruta:'/mun/general/premmiosr'}
              { tag:'informes',ruta:'/mun/general/informesresultado'},*/
            
         ]},

         { tag:'indicadores',child:true,active:false,childs:
         [
/*

  {tag:'catalogos',child:true,active:false,childs:

         [
                
 
            //Catalogos
          { tag:'indicadores_areas',child:false,active:false,ruta:'/mun/general/indicadores/catalogos/areas'},
          { tag:'indicadores_clasificaciones',child:false,active:false,ruta:'/mun/general/indicadores/catalogos/clasificaciones'},
         // { tag:'indicadores_dimensiones',child:false,active:false,ruta:'/mun/general/indicadores/catalogos/dimensiones'},
          { tag:'indicadores_frecuencias',child:false,active:false,ruta:'/mun/general/indicadores/frecuencias'},
         
         ]},*/
      /*   {tag:'variables',child:true,active:false,childs:

         [
                
 
           //Variables
        //  { tag:'indicadores_unidad_medidas',child:false,active:false,ruta:'/mun/general/indicadores/variables/unidadmedidas'},
         // { tag:'indicadores_fuentes_informacion',child:false,active:false,ruta:'/mun/general/indicadores/variables/fuentes'},
          { tag:'indicadores_variables',child:false,active:false,ruta:'/mun/general/indicadores/variables/variables'},
      ]},
*/
         
//{ tag:'indicadores_desempeno_enlaces',child:false,active:false,ruta:'/mun/general/indicadores/desempenoEnlaces'},
         // { tag:'form_indicadores_administradores',child:false,active:false,ruta:'/mun/general/indicadores/formAdministradores'},
        
         { tag:'indicadores_administradores',child:false,active:false,ruta:'/mun/general/indicadores/administradores'},
         { tag:'indicadores_clasificaciones',child:false,active:false,ruta:'/mun/general/indicadores/catalogos/clasificaciones'},
         { tag:'indicadores_variables',child:false,active:false,ruta:'/mun/general/indicadores/variables/variables'},
          { tag:'indicadores_valores_variables',child:false,active:false,ruta:'/mun/general/indicadores/capVariable'},
        //  { tag:'indicadores_formulas',child:false,active:false,ruta:'/mun/general/indicadores/formula'},
         

          
        origin
        ]}, 
          { tag:'poas',child:true,active:false,childs:
         [
          { tag:'pmdArbol',child:false,active:false,ruta:'/mun/poa/arbol'},
           //  { tag:'problembuilder',child:false,active:false,ruta:'/mun/poa/builder'},
           
           
           
             

               { tag:'poas',child:false,active:false,ruta:'/mun/poa/poas'},
                 // { tag:'techos_report',child:false,active:false,ruta:'/mun/poa/techos_repor'},
                 { tag:'techos',child:false,active:false,ruta:'/mun/poa/techos'},
                  { tag:'techos_departamento',child:false,active:false,ruta:'/mun/poa/techos_depa'},

            
                // { tag:'poa_linea_accion',child:false,active:false,ruta:'/mun/poa/linea'},

           {tag:'conac',child:true,active:false,childs:

         [
                { tag:'poa_finalidades',child:false,active:false, ruta:'/mun/poas/conac/finalidades'},
                //{ tag:'poa_Gobierno',child:false,active:false, ruta:'/mun/poas/conac/gobierno'},
            // { tag:'poa_funciones',ruta:'/mun/poas/conac/funciones'},
             //{ tag:'poa_subfunciones',ruta:'/mun/poa/conac/subfunciones'},
             { tag:'poa_programaticas',ruta:'/mun/poa/conac/tipodegastos'},
             { tag:'poa_clasif_funcionales',ruta:'/mun/poa/conac/otrotipodegastos'},
             { tag:'poa_capitulos_conac',ruta:'/mun/poa/conac/capconac'},
          
 
            
         ]},


           /*  { tag:'departamentos',ruta:'/mun/general/departamentos'},
            { tag:'sitiosinteres',ruta:'/mun/general/sitiosi'},
             { tag:'premios_reconocimeintos',ruta:'/mun/general/premmiosr'}
              { tag:'informes',ruta:'/mun/general/informesresultado'},*/

            
         ]},







         { tag:'reportes',child:true,active:false,childs:
         [

             { tag:'detalle_fisico',child:false,active:false,ruta:'/mun/reportes/detallefisico'},
           //  { tag:'estadistico_fisico',child:false,active:false,ruta:'/mun/reportes/estadisticofisico'}, 
            //{ tag:'estadistico_pps',child:false,active:false,ruta:'/mun/reportes/estadisticopps'},
//{ tag:'indicadores_variables',child:false,active:false,ruta:'/mun/reportes/indicadoresvariables'},
            // { tag:'pmd_importes',child:false,active:false,ruta:'/mun/reportes/pmdimportes'},
            // { tag:'rep_excel',child:false,active:false,ruta:'/mun/reportes/repexcel'},
            { tag:'rep_trimestre',child:false,active:false,ruta:'/mun/reportes/reptrimestre'},
             { tag:'rep_financiero',child:false,active:false,ruta:'/mun/reportes/financiero'},
           // / { tag:'validar_avance_fisico',child:false,active:false,ruta:'/mun/reportes/validavancefisico'},
            // { tag:'validar_importe_pps',child:false,active:false,ruta:'/mun/reportes/importe_pps'},
            // { tag:'valores_variables',child:false,active:false,ruta:'/mun/reportes/valoresvariables'},
            
         ]},
          
      ]

      
    },

    labels:{
      problembuilder:'Creador de problemas',
      poaFinalidades:'Poa Finalidades',
      pmd:'Pmd', 
      table:{
        active:'Activo',
        add:'Crear',
        delete:'Eliminar',
        edit:'Editar',
        linea:'Avance Financiero',
        lineaAccion:'Avance Físico ',
        select_pmd_estr_eje:'Estrategia del PMD',
        select_dim:'Seleccionar dimensiones',
        select:'Seleccionar',
        select_dep:'Ver departamento',
        select_eje:'Ver eje',
        select_estrategia:'Ver estrategia',
        select_linea:'Ver linea',
        select_fun:'Ver función',
        select_sub:'Ver subfunción',
        select1:'Linea Acción',
        select2:'Actividad Linea Acción',
         role:'Rol',
          modifico:'Modifico',
           municipio:'Municipio',
           password_plano:'Password',
             email:'Correo',
         id:'#',
           idtema:'Tema',
              descripcion:'Descripción',
              total_poas:'Total Poas',
              monto:'Monto',
              latitud:'Latitud',
               longitud:'Longitud',
                nombre:'Nombre',
                 numero:'Número',
                  contacto:'Contacto',
                   logotipo:'Logotipo',
                   visible:'Visible',
                   indicador_administradores_id:'Indicador Administradores',
                   imprimirpoa:'Imprimir Poa',
                   objetivo:'Objetivo',
poas:'Poas',
fin:'Fin',
proposito:'Proposito',

descuento:'Descuento',
 //Sistema_Poa Usuarios
 idusuario: 'Id Usuario', 
 idpoa:'Poa' ,

 //Sistema pagos municipios
 idmunicipio: 'Id Municipio',
 //monto: 'monto', 
 
 //Poa_techo_capitulos
 capitulo:'Capitulo', 
 importe: 'Importe', 
 estatus: 'Estatus', 
 serie:'Serie', 
 created_at:'Created_at',
 finaliza_pmd:'Finaliza',
 //Poa_series
 ano: 'Año',
// estatus:'estatus',//////////////
 
//Poa Finalidades
 clave:'Clave', 
 finalidad: 'Finalidad',
 //estatus:'estatus',

 //Poa_Clasifcicacion
 tipo_gasto: 'Tipo Gasto',
// estatus: 'estatus',

//Poa_Clasificacion_funcionalidad
otro_tipo_gasto:'Otro Tipo de Gasto', 
// estatus:'estatus',

//Poa_Cap_Conacs
// clave: 'clave', 
//  capitulo:'capitulo',
//  estatus:'estatus',

//Pmds
nombre_pmd:'Nombre Pmd'   ,
ano_pmd:'Ano Pmd', 

// estatus:'estatus',
eje_rector:'Eje Rector',
estrategias:'Estrategias', 
//clave: 'clave', 
linea_accion:'Linea Acción',

//´pmd_inicios
//ano:'ano',
//estatus: 'estatus',
//municipio:'municipio', 

//pmd_ estrategias
//eje_rector:'eje_rector', 
//clave:'clave',
 //estrategias:'estrategias',

 //PMD EJe rector
 pmd:'Pmd', 
 //clave:'clave', 
 nombre_eje:'Nombre Eje', 
 //estatus:'estatus',


 //General Sitios Inter
 //nombre:'nombre', 
 //descripcion:'descripcion',
 pagina_web:'Página Web',
 //estatus:'estatus',

//General Secrre
//nombre:'nombre',
fecha_alta:'Fecha Alta', 
tipo:'Tipo', 
total_empleados :'Total Empleados', 
nombre_titular :'Nombre Titular', 
correo:'Correo', 
abreviacion:'Abreviación',
//estatus :'estatus', 

//general informes resultados
fecha:'Fecha',
nombre_documento:'Nombre Documento',
tipo_informe:'Tipo Informe',
orden: 'Orden', 
//ano:'ano', 
//estatus:'estatus',
documento:'Documento',

//general departametos
nombre_secretaria:'Nombre Secretaria', 
//clave:'clave', 
departamento:'Departamento', 
secretaria:'Secretaría', 
//estatus:'estatus', 
nombre_enlace:'Nombre Enlace',

area_indicador: 'Area Indicador',
clasificacion:'Claficiación',
indicadores_clasificacion:'Indicador Clasificación',
tipo_indicador:'Tipo Indicador',
dimension:'Dimensión',
frecuencia:'Frecuencia',
mes:'Mes', 
num_mes:'Numero Mes', 
fuente:'Fuente',
//Departamentos
NOMBRE:'Nombre',
plantas_id:'Plantas Id',
identificacion:'Identificación',
problema:'Problema',
efectos:'Efectos',
causas:'Causas',
unidad_medida:'Unidad Medida',
objetivo_indicador:'Objetivo Indicador',
variables_agregadas:'Variables Agregadas',
formula:'Fórmula',
unidad_medida_resultado:'Unidad medida',
valor_min:'Valor Mínimo',
valor_max: 'Valor Maxímo',
meta:'Meta',
aceptado:'Aceptado',
motivo:'Motivo',
abreviasion:'Abreviación',
funciones:'Funciones',
nombre_catalogo:'Nombre',
enero:'Enero',
febrero:'Febrero',
marzo:'Marzo',
abril:'Abril',
mayo:'Mayo',
junio:'Junio',
julio:'Julio',
agosto:'Agosto',
septiembre:'Septiembre',
octubre:'Octubre',
noviembre:'Noviembre',
diciembre:'Diciembre',
idvariable:'Variable',
idserie:'Serie',
idfrecuencia:'Frecuencia',
codigo_formula:'Código Fórmula',
color:'Color',
idprogramatica:'Programática',
poblacion_objetivo:'Población Objetivo',
tipo_poblacion:'Tipo Población',
subfunciones:'Subfunciones',
Descripcion:'Descripción',
UnidadActividad:'Unidad Actividad',
fecha_inicial:'Fecha Inicial',
fecha_final:'Fecha Final',
imprimirIndicador:'Imprimir Indicador',
idmir:'MIR',
idarboledit:'Árbol problema',
imprimirArbol:'Imprimir árbol',
idobjetivos:'Árbol Objetivos',









            },
            reportes:'Reportes',
            detalle_fisico:'Detalle Físico',
            estadistico_fisico:'Estadistico Físico',
            estadistico_pps:'Estadistico PPS',
            indicadores_variables:'Indicadores Variables',
            pmd_importes:'Pmd Importes',
            rep_excel:'Rep Excel',
            rep_financiero:'Reporte Financiero',
            rep_trimestre:'Rep Trimestre',
            validar_avance_fisico:'Validar Avance Físico',
            validar_importe_pps:'Validar Importe PPS',
            valores_variables:'Valores Variables',
      dashboard:'Inicio',
       municipios:'Municipios',
        paquetes:'Paquetes',
         pagos:'Pagos',
          reporteador:'Reporteador',
           usuarios:'Usuarios',
            dependencias:'Dependencias',
            departamentos:'Departamentos',
            informes:'Informes',
            sitiosinteres:'Sitios de Interes',
            usuarios_municipio: 'Usuarios',
            indicadores_areas: 'Indicadores Áreas',
            indicadores_unidad_medidas:'Indicadores Medidas',
            premios_reconocimeintos:'Premios y Reconocimientos',
            general:'General',
            poa_Gobierno:'CLASIFICACIÓN FUNCIONAL DEL GASTO',
            indicadores_fuentes_informacion:'Indicador Fuentes Información',
            indicadores_clasificaciones:'Indicador Clasificaciones',
            indicadores_dimensiones:'Indicador Dimensiones',
            indicadores_frecuencias:'Indicador Frecuencias',
            indicadores:'Indicadores',
            variables:'Variables',
            poas: 'Poas',
            indicador_mes_frecuencias:'Indicador Mes Frecuencia',
            indicador_series:'Indicador Series',
            poa_series:'Año fiscal',
            pmdArbol:'Crear Programa',
         
            indicadores_desempeno_enlaces:'Indicador Desempeño Enlaces',
            indicadores_administradores:'Indicador Admistradores',
            form_indicadores_administradores:'Indicador Form Administradores',
            poa_finalidades:'Finalidad',
              conac:'CONAC',
              poa_capitulos_conac:'Capitulos CONAC',
               
                  catalogos:'Cátalogos',
techos_report:'Reporte Techos Presupuestales',
                      techos:'Presupuesto Municipal',
techos_departamento:'Techos Departamento',
            poa_programaticas:'Clasif. Programática',

            poa_funciones:'Poa Funciones',
            poa_subfunciones:'Poa Subfunciones',
            indicadores_valores_variables:'Valores Variables',
            poa_clasif_funcionales:'Clasif. Funcional',
            indicadores_formulas:'Generador Fórmula',
            poa_linea_accion:' Poa Linea de Acción',
           },
            
          
    
  },
  mutations: {
    initialiseStore(state,store:any) {
			// Check if the ID exists
		
				this.replaceState(
					Object.assign(state, store)
				);
			
    },
      SETLOADING: (state, data:any) =>
    {state.loading = data;},
      SETPROBLEMA: (state, data:any) =>
    {state.arbol_problema = data;},
    
    SETINDICADORPDF: (state, data:any) =>
    {state.indicador_administrador = data;},

     SETOBJETIVO: (state, data:any) =>
    {state.objetivo_sel = data;},
       SETMIR: (state, data:any) =>
    {state.mir_obj = data;},
    SETUSERMUNI: (state, data:any) =>
    {state.usu_muni = data;},
      SETUSER: (state, usuario:any) =>
    {state.user = usuario;},
       SETSECRETARIA: (state, data:any) =>
    {state.secretaria_sel = data;},
    SETDEPARTAMENTO: (state, data:any) =>
    {state.departamento_sel = data;},
    SETIMF: (state, data:any) =>
    {state.frecuancia_sel = data;},

    SETIFINA: (state, data:any) =>
    {state.finalidad_sel = data;},
     SETPMD: (state, data:any) =>
    {state.pmd_sel = data;},
    SETEJE: (state, data:any) =>
    {state.eje_sel = data;},
     SETESTRATEGIA: (state, data:any) =>
    {state.estrategia_sel = data;},
     SETLINEA: (state, data:any) =>
    {state.lineas_sel = data;},
    SETPOAFUN: (state, data:any) =>
    {state.funciones_sel = data;},

    SETPOA: (state, data:any) =>
    {state.poa_sel = data;},
       SETPOASEL: (state, data:any) =>
    {state.poasel = data;},
    SETLINEAACCION: (state, data:any) =>
    {state.linea_accion_sel = data;},
    SETINDICADOR: (state, data:any) =>
    {state.indicador_administrador_sel = data;},
    SETINDICADORAREA: (state, data:any) =>
    {state.indicador_area_sel = data;},

    SETGOBIERNO: (state, data:any) =>
    {state.gobierno_sel = data;},
    SETSOCIALES: (state, data:any) =>
    {state.sociales_sel = data;},

  },
  actions: {

    LOGIN: async function(context, data) {




      
      var result =  await axios
        ({
          method: 'POST',
          url: base+"auth/login" ,
          responseType: 'json',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              "Content-Type": "application/json",

            },data: {
              email:data.usuario,
              password:data.contrasena,
            
            }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },

    
  },
  modules: {
  }
})
